export default __webpack_public_path__ + "static/media/photo.46d3a941.svg";